import axiosInstance from '../../lib/axios';

export const fetchNotifications = async (params = {}) => {
  const response = await axiosInstance.get('/notifications/', { params });
  return response.data;
};

export const fetchNotificationById = async (id) => {
  const response = await axiosInstance.get(`/notifications/${id}/`);
  return response.data;
};

export const createNotification = async (data) => {
  const response = await axiosInstance.post('/notifications/', data);
  return response.data;
};

export const deleteNotification = async (id) => {
  const response = await axiosInstance.delete(`/notifications/${id}/`);
  return response.data;
};

export const bulkDeleteNotifications = async (notificationIds) => {
  const response = await axiosInstance.post('/notifications/bulk/delete/', {
    notification_ids: notificationIds,
  });
  return response.data;
};

export const fetchNotificationLogs = async (params = {}) => {
  const response = await axiosInstance.get('/notifications/logs/', { params });
  return response.data;
};

export const fetchNotificationStats = async (id) => {
  const response = await axiosInstance.get(`/notifications/${id}/stats/`);
  return response.data;
};
